var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"an-note-open btn",attrs:{"tag":"button","to":{ query: Object.assign({}, _vm.$route.query), hash: 'notiz' },"replace":""}},[_c('span',[_vm._v("Notiz")]),_c('IconEdit',{staticClass:"icon-edit"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }